import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Company } from '../index';
import { useAppMutation } from '../use-app-mutation.hook';
import { PatchSharedCapTableLinkDto } from './shared-cap-table.types';

type UpdateVariables = { id: string } & PatchSharedCapTableLinkDto;

export const useSharedCapTableLinkUpdate = () => {
  const queryClient = useQueryClient();
  const { selectedCompanyId: companyId } = Company.useSelected();

  const { isPending, mutate: updateLink } = useAppMutation<unknown, unknown, UpdateVariables>(
    [QueryKey.SHARED_CAP_TABLE_LINK_UPDATE, companyId],
    {
      mutationFn: ({ id, ...body }) =>
        ApiService.patch(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'shared-cap-table-links', id],
          },
          { body },
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryKey.SHARED_CAP_TABLE_LINKS] });
      },
    },
  );

  return { isPending, updateLink };
};
